<div class="workspace-outer-container">
  <div class="workspace-inner-container">
    <comparables-valuations-grid [hidden]="!showGrid" [workspace]="this"></comparables-valuations-grid>
    <comparables-valuations-form [oid]="oid" *ngIf="!showGrid && oid !== null"
                   [workspace]="this"
                   [showPrevBtn]="previousButtonEnabled"
                   [showNextBtn]="nextButtonEnabled"
                   (showPrevious)="showPrevious()"
                   (showNext)="showNext()">
    </comparables-valuations-form>
  </div>
</div>
